'use client';
import React, { useEffect, useRef } from 'react';
import Link from 'next/link';

const faqPreview = [
  {
    question: 'Bagaimana sistem pembayaran untuk layanan IoT di Agro Teknologi Nusantara?',
    answer: 'Layanan IoT kami menggunakan sistem berlangganan berbasis titik perangkat (per node). Tarif dikenakan per bulan per titik dan dapat disesuaikan dengan kebutuhan.',
  },
  {
    question: 'Apakah Agro Teknologi Nusantara menyediakan pelatihan pertanian berbasis teknologi?',
    answer: 'Ya, tersedia metode online (via LMS) dan offline (hands-on di laboratorium Agro Teknologi Nusantara) dengan panduan mentor profesional dan kurikulum step-by-step.',
  },
  {
    question: 'Apakah data pertanian saya akan digunakan oleh Agro Teknologi Nusantara?',
    answer: 'Data dari perangkat IoT digunakan secara anonim untuk forecasting, penelitian, dan inovasi. Kami tidak menjual data untuk komersial tanpa izin.',
  },
];

export default function FAQSection() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );
    const els = ref?.current?.querySelectorAll('.reveal');
    els?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section id="faq" ref={ref} className="relative bg-canopy blueprint-grid py-24 md:py-32 px-6 md:px-10">
      <div className="max-w-4xl mx-auto">
        <div className="reveal flex items-center gap-4 mb-4">
          <div className="w-12 h-px bg-chartreuse opacity-60" />
          <span className="annotation">PERTANYAAN UMUM</span>
        </div>
        <h2 className="reveal delay-100 font-mono font-bold text-4xl md:text-5xl text-text-primary mb-4 leading-tight">
          PERTANYAAN<br />
          <span className="text-chartreuse">YANG SERING DIAJUKAN</span>
        </h2>
        <p className="reveal delay-200 text-text-muted text-lg mb-12 leading-relaxed">
          Jawaban singkat untuk pertanyaan yang paling sering masuk ke tim kami.
        </p>
        <div className="reveal delay-200 flex flex-col gap-4 mb-10">
          {faqPreview.map((faq, i) => (
            <div
              key={i}
              className="border border-chartreuse/15 rounded-sm p-6 bg-pond/30 hover:border-chartreuse/25 transition-colors"
            >
              <h3 className="font-mono font-bold text-text-primary text-sm mb-3">
                {faq.question}
              </h3>
              <p className="text-text-muted text-sm leading-relaxed">
                {faq.answer}
              </p>
            </div>
          ))}
        </div>
        <div className="reveal delay-300 text-center">
          <p className="text-text-muted text-sm mb-4">
            Ada pertanyaan lain yang belum terjawab?
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              href="/faq"
              className="btn-chartreuse px-8 py-4 rounded-sm text-sm uppercase tracking-widest inline-block"
            >
              Lihat Semua FAQ (9 Pertanyaan) →
            </Link>
            <a
              href="https://wa.me/6281253837777?text=Halo%20Agro Teknologi Nusantara,%20saya%20punya%20pertanyaan"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-outline-chartreuse px-8 py-4 rounded-sm text-sm uppercase tracking-widest inline-block"
            >
              Tanya via WhatsApp
            </a>
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 rule-line" />
    </section>
  );
}
